
import { mapGetters } from 'vuex'
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vxCurrency: 'currency/getCurrency',
    }),
    locale() {
      const locales = {
        USD: { fr: 'fr_CA', default: 'en_US' },
        CAD: { fr: 'fr_CA', default: 'en_CA' },
      }
      return (
        locales[this.vxCurrency]?.[this.$i18n.locale] ||
        locales[this.vxCurrency]?.default ||
        'en_US'
      )
    },
  },
}
